import React, { useEffect, useRef, useState } from 'react'

import ListItem from '@mui/material/ListItem';
import { FixedSizeList } from 'react-window';
import './HomePageRes.css'
import { get_all_events } from '../../Api/homeapi'
import Post from '../Components/Post';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import SearchIcon from '../../assets/general/search.svg'
import { useNavigate } from 'react-router-dom';
import GifLoader from '../Components/GifLoader';
import { apigetFirstname } from '../../Api/firebaseAPis';



function HomePageRes() {
  const [upcomingClass, setUpcomingClass] = useState("selected-tab tab")
  const [recentClass, setRecentClass] = useState("tab")
  const [eventData, setEventData] = useState({})
  const [recentEvents, setrecentEvents] = useState({})
  const [comingEvents, setcomingEvents] = useState({})
  const [value, setValue] = React.useState('recents')
  const [allValue, setAllValue]=useState([])
  const [items, setItems] = useState('')
  const [loader,setLoader]=useState(false)
  const eventDataMain = useSelector(state => state.Event).eventData
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const data = useRef();
  const [fn,setfn]=useState('');
  useEffect(() => {
    const action = {
      type: 'SET_SHOW_NAVIGATOR',
      showNavigator: true
    }
    dispatch(action)
  },[])

  function renderRow(props) {
    const { index, style } = props;    

    return (
      <ListItem style={style}>
        <Post data={props.data ? eventData[props.data[index]] : ""} id={props.data ? props.data[index] : ""} />
      </ListItem>
    );
  }

  useEffect(() => {
    if (!eventDataMain) {
      getAsyncData()
    } else {
      sortData(eventDataMain)
    
    }
    // dataRef.ref().child("displayname").on('value', data => {
      // const getData=Object.values(data.val())
    // })

  }, [])

  const sortData = (all_events) => {
    var postX = Object.keys(all_events).map(function (key) {
      all_events[key]['data']['id'] = key
      return all_events[key]['data'];
    });
    if (postX.length === 0) {
      setEventData([])
    } else {
      setEventData(postX.reverse())
    }
    let uEvents = []
    let rEvents = []
    for (var i in postX) {
      var currentDate = new Date(Date.now())
      let endTimeMoment = moment(postX[i].endTime)
      let currentTimeMoment = moment(currentDate)
      if (currentTimeMoment.isAfter(endTimeMoment)) {
        rEvents.push(postX[i])
      } else {
        uEvents.push(postX[i])
      }
    }
    if (uEvents.length > 0) {
      setcomingEvents(uEvents);
    }
    if (rEvents.length > 0) {
      setrecentEvents(rEvents);
    }

    
  }

  const getAsyncData = async () => {
    setLoader(true)
    const uid = localStorage.getItem('uid')
 
    const all_events = await get_all_events(uid)
    const action = {
      type: 'SET_EVENT_DATA',
      eventData: all_events
    }
    dispatch(action)

    sortData(all_events)
    setLoader(false)
  }


  const onclick = () => {
    setUpcomingClass("selected-tab tab")
    setRecentClass("tab")
  }

  const clickRecent = () => {
  
    setRecentClass("selected-tab tab")
    setUpcomingClass("tab")
  }

 const getfirstname=async()=>{
let id=localStorage.getItem('uid');
let x= await apigetFirstname(id);
setfn(x);
 }
useEffect(()=>{
  getfirstname();
},)

  return (
    <>
      {loader?<GifLoader/>:
      <div>
      {/* <Header /> */}
      <div className='row' style={{ justifyContent: 'space-between', padding: 20 }}>
        <div>
          <h5 style={{ fontSize: 16, textAlign: 'left' }}>Hi {fn},</h5>
          <p style={{ fontSize: 12 , position: 'absolute'}}>Welcome to surge</p>
        </div>
        <div className='search-circle' onClick={() => navigate("/search")}>
          <img style={{ width: 20 }} src={SearchIcon} />
        </div>
      </div>
      <div className='row center gap-top gap-bottom'>
        <div className={upcomingClass} onClick={() => onclick()}>
          Upcoming
        </div>
        <div className={recentClass} onClick={() => clickRecent()}>
          Recent
        </div>
      </div>
      {(Object.keys(comingEvents).length===0 && upcomingClass === "selected-tab tab")?
       <div style={{paddingTop:"20%", color:"white"}}>No Upcoming Events</div>
      :<></>}
      {(Object.keys(recentEvents).length===0 && recentClass === "selected-tab tab")?
       <div style={{paddingTop:"20%", color:"white"}}>No Recent Events</div>
      :<></>}
      <FixedSizeList
        height={1000}
        width={"100%"}
        itemSize={120}
        style={{height: '100%'}}
        itemCount={upcomingClass === "selected-tab tab" ? Object.keys(comingEvents).length : Object.keys(recentEvents).length}
        overscanCount={5}
        itemData={upcomingClass === "selected-tab tab" ? Object.keys(comingEvents) : Object.keys(recentEvents)}
      >
        {renderRow}
      </FixedSizeList>

    </div>
      }
    </>
    
  )
}

export default HomePageRes